import { lazy, Suspense } from 'react';

import { Reveal } from '@/components/reveal';
import { Section } from '@/components/section';
import { company } from '@/data/company';

const ServiceAreaMap = lazy(async () => ({
  default: (await import('./service-area-map')).ServiceAreaMap,
}));

const MapSkeleton = (): React.ReactNode => (
  <div
    className="aspect-[4/3] w-full overflow-hidden rounded-lg border border-stone bg-stone/40 sm:aspect-[3/2]"
    aria-hidden="true"
  />
);

export function ServiceAreaSection(): React.ReactNode {
  return (
    <Section background="paper" spacing="loose">
      <div className="grid gap-16 lg:grid-cols-2 lg:items-center">
        <Reveal>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.3em] text-moss">
            Wo wir arbeiten
          </p>
          <h2 className="mb-6 font-display text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.05] tracking-tight">
            Hamburg, Stormarn,
            <br />
            Lübeck und das ganze
            <br />
            <span className="text-moss">nördliche Land.</span>
          </h2>
          <p className="mb-2 max-w-md text-mute">
            Wir sind in {company.serviceArea} unterwegs. Schwerpunkt: Hamburg, Stormarn (Ahrensburg,
            Bargteheide, Reinbek, Glinde), Lübeck, Norderstedt, Pinneberg.
          </p>
          <p className="text-sm text-mute">
            Außerhalb des Gebiets? Sprechen Sie uns an – für größere Aufträge fahren wir auch
            weiter.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <Suspense fallback={<MapSkeleton />}>
            <ServiceAreaMap />
          </Suspense>
        </Reveal>
      </div>
    </Section>
  );
}
